import React  from 'react';



const MessageSent = (props) => {
const { msg } = props;


    return (
        <span className="message even message3" id={msg.id}>
            <div className="icon"><img src={msg.icon} /></div>
            <p>{msg.data} </p><div></div>
            <span className="time"> {msg.time} </span>
        </span>
    );
};

export default MessageSent;